
const VoiceSquareIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5459 6.62402V9.12655" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.2959 5.78955V9.95456" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.0459 4.95557V10.7889" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.7959 5.78955V9.95456" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.5459 6.62402V9.12655" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.29598 13.7052H8.79598C11.7126 13.7052 12.8793 12.5386 12.8793 9.62191V6.12191C12.8793 3.20524 11.7126 2.03857 8.79598 2.03857H5.29598C2.37931 2.03857 1.21265 3.20524 1.21265 6.12191V9.62191C1.21265 12.5386 2.37931 13.7052 5.29598 13.7052Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default VoiceSquareIcon
